export type BedStatus = "available" | "occupied" | "reserved" | "maintenance";

export type StayStatus = "pending" | "active" | "discharged";

export interface HospitalWard {
  id: string;
  code: string;
  name: string;
}

export interface HospitalRoom {
  id: string;
  wardId: string;
  roomNumber: string;
}

export interface HospitalBed {
  id: string;
  roomId: string;
  label: string;
  status: BedStatus;
  currentStayId: string | null;
}

export interface HospitalStay {
  id: string;
  patientId: string;
  admissionId: string | null;
  bedId: string | null;
  wardName: string;
  status: StayStatus;
  admittedAt: string;
  /** Date d'attribution du lit — base des nuitées facturées. */
  bedAssignedAt: string | null;
  dischargedAt: string | null;
  attendingPractitionerId: string | null;
  attendingPractitioner: string;
  motif: string;
}

export interface BedWithLocation {
  bed: HospitalBed;
  room: HospitalRoom;
  ward: HospitalWard;
  stay: HospitalStay | null;
}

export const BED_STATUS_LABELS: Record<BedStatus, string> = {
  available: "Libre",
  occupied: "Occupé",
  reserved: "Réservé",
  maintenance: "Maintenance",
};

export const STAY_STATUS_LABELS: Record<StayStatus, string> = {
  pending: "En attente de lit",
  active: "Hospitalisé",
  discharged: "Sorti",
};

export function bedDisplayLabel(bed: HospitalBed, room: HospitalRoom): string {
  return `Ch. ${room.roomNumber} — Lit ${bed.label}`;
}
